var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.game == 'repense')?_c('h2',{staticClass:"workspace-title",style:({
        color: _vm.colors.primary,
    })},[_vm._v(_vm._s(_vm.title))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }